import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../../store';
import { closeFeedbackFormPopup } from '../../../actions/feedback';
import { FeedbackFormPopup } from './FeedbackFormPopup';

export const mapStateToProps = (state: IState) => ({
  isOpen: state.feedback.isPopupOpened,
});

export const mapDispatchToProps = (dispatch: Dispatch<{}>) => ({
  onClose() {
    dispatch(closeFeedbackFormPopup());
  },
});

export const FeedbackFormPopupContainer = connect(mapStateToProps, mapDispatchToProps)(FeedbackFormPopup);
